import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { ProductName, ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductName } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productName: ProductName;
}

type Props = OwnProps & ConnectedProps;

export class ProductNameTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productName } = this.props;

        return <TableCell>{productName}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productName: makeSelectProductName()
});

export default connect(mapStateToProps)(ProductNameTableCellComponent);
